




















































































































import {
  apiOrderWriteOffOrderList,
  ApiOrderWriteOffOrderListResponse,
  apiSaleAfterWriteOffOrderSaleAfterList,
} from '@/api'
import { BookOrderComponents } from './components'
import { defineClassComponent, useQuery } from '@/hooks'
import { ItemOf, requiredDeep, Track } from '@/utils'
import { navigateTo } from '@/router'
import { ref } from '@vue/composition-api'
import { useWaterfall, XWaterfallLoad } from '@/components'

type OrderItem = ItemOf<ApiOrderWriteOffOrderListResponse> & {
  isRefund: boolean
}

export default defineClassComponent<{
  embed: boolean
  noCompleteTips: boolean
  activeIndex: number
}>(
  {
    components: BookOrderComponents,
    props: ['embed', 'noCompleteTips', 'activeIndex'],
  },
  ({ props }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '商品详情',
        }))
      }

      query = useQuery<{
        activeIndex: number
      }>({
        activeIndex: {
          default: props.activeIndex || 0,
          transformer: Number,
        },
      })

      categoryList: Array<{
        label: string
        value: number
        status: number
      }> = [
        {
          label: '全部',
          value: 0,
          status: 0,
        },
        {
          label: '待付款',
          value: 1,
          status: 1,
        },
        {
          label: '待使用',
          value: 2,
          status: 2,
        },
        {
          label: '待评价',
          value: 3,
          status: 3,
        },
        {
          label: '退款/售后',
          value: 4,
          status: 4,
        },
      ]

      currentCategoryIndex = ref<number>(this.query.activeIndex)

      listWaterfall = useWaterfall<string>('list', {
        reloadWatcher: () => this.currentCategoryIndex.value,
      })

      handleListLoad: XWaterfallLoad = ({ pageNumber }) => {
        return this.categoryList[this.currentCategoryIndex.value].status === 4
          ? apiSaleAfterWriteOffOrderSaleAfterList({
              pageIndex: pageNumber,
              pageSize: 10,
            })
              .then(requiredDeep)
              .then(res => ({
                ...res,
                list: res.list.map(item => ({
                  ...item,
                  orderNo: item.saleId,
                  isRefund: true,
                })),
              }))
          : apiOrderWriteOffOrderList({
              pageIndex: pageNumber,
              pageSize: 10,
              status:
                this.categoryList[this.currentCategoryIndex.value].status,
            }).then(requiredDeep)
      }

      handleListItemCheck = async (item: OrderItem) => {
        if (item.isRefund) {
          return item
        }
        const {
          list: [newItem],
        } = await apiOrderWriteOffOrderList({
          pageIndex: 1,
          pageSize: 1,
          status: this.categoryList[this.currentCategoryIndex.value].status,
          orderNo: item.orderNo,
        }).then(requiredDeep)
        return newItem
      }

      handleListItemClick = (item: OrderItem) => {
        if (item.isRefund) {
          navigateTo('BookRefundResult', {
            refundId: item.orderNo,
          })
        } else {
          navigateTo('BookOrderDetail', {
            orderNo: item.orderNo,
          })
        }
      }

      handleListItemRefresh = (item: OrderItem) => {
        this.listWaterfall.checkRecord(item.orderNo, 1500)
      }
    },
)
